import type { ReactElement } from 'react'
import { PaperGrad, BeadyEye, STROKE, SHADOW, type GlyphProps } from './shared'

/* SNAKE — folded zigzag body with small head */
export const Snake = ({ size = 110 }: GlyphProps): ReactElement => (
  <svg width={size} height={size} viewBox="0 0 120 120" style={SHADOW}>
    <defs>
      <PaperGrad id="snake-l" light="#fff2c2" dark="#f5d271"/>
      <PaperGrad id="snake-d" light="#f5d271" dark="#c89a32"/>
    </defs>
    <polygon points="6,102 26,84 14,60 42,46 32,28 60,18 70,40 56,54 82,60 70,82 100,78 106,102"
             fill="url(#snake-l)" stroke={STROKE} strokeWidth="2.2" strokeLinejoin="round"/>
    {/* shaded underbelly */}
    <polygon points="6,102 26,84 32,96 18,98" fill="url(#snake-d)" opacity="0.6" stroke={STROKE} strokeWidth="0.7" strokeDasharray="2 2"/>
    <polygon points="60,18 70,40 64,32" fill="url(#snake-d)" opacity="0.6" stroke={STROKE} strokeWidth="0.7" strokeDasharray="2 2"/>
    {/* head */}
    <polygon points="60,18 78,8 70,28" fill="url(#snake-l)" stroke={STROKE} strokeWidth="1.8" strokeLinejoin="round"/>
    <polygon points="78,8 86,14 76,18" fill="url(#snake-d)" stroke={STROKE} strokeWidth="1.4" strokeLinejoin="round"/>
    {/* zigzag fold lines */}
    <line x1="26" y1="84" x2="42" y2="46" stroke={STROKE} strokeWidth="0.7" strokeDasharray="2 2"/>
    <line x1="42" y1="46" x2="70" y2="40" stroke={STROKE} strokeWidth="0.7" strokeDasharray="2 2"/>
    <line x1="56" y1="54" x2="82" y2="60" stroke={STROKE} strokeWidth="0.7" strokeDasharray="2 2"/>
    <line x1="82" y1="60" x2="70" y2="82" stroke={STROKE} strokeWidth="0.7" strokeDasharray="2 2"/>
    <BeadyEye cx={70} cy={18} r={1.6}/>
  </svg>
)
